import './styles/style.css';
import './favicon.ico';

import { initContactForm } from './browser/contact-form';
import { initMobileContact } from './browser/mobile-contact';

initContactForm();
initMobileContact();
